import { CategoryTab } from '@shared/types/mylounge';

const forYouTab: CategoryTab = {
    id: 'for-you',
    name: 'For You',
    globalRetailEvent: false,
    thb: { type: 'NONE' as const },
    event: '',
};

export const createTabListWithForYou = (baseTabs: CategoryTab[]) => {
    const addFirstToEndBase = [...baseTabs.slice(1), baseTabs[0]];

    return [forYouTab, ...addFirstToEndBase];
};
